export default {
  CLEAR_PROFILE(state) {
    state = {
      name: '',
      isAdmin: false
    }
  },
  GET_PROFILE_SUCCESS(state, data) {
    state.name = data.name
    state.isAdmin = data.isAdmin
    state.getProfileError = ''
  },
  GET_PROFILE_ERROR(state, error) {
    state.getProfileError = error
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js